import React from 'react';
import SessionService from '../../services/session.service';
import { loginService } from '../../services/login.service';
class CommonMessage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isMsgClose: false,
            isCreateExternalDisabled: !loginService.isInternalUser()
        };
    }

    fadeOut() {
        if(this.props.message !== "Link your credit card for deploying high-speed NVMe SSD servers in seconds" && this.props.message !== "We are currently not supporting <b>instance creation</b> due to limited capacity.") {
            if(this.props.message && this.props.message !== '') {
                this.parentCommonMsgTimeout = setTimeout(() => { this.props.handler(); }, 8000);
            }
        }
    }

    componentWillUnmount() {
        if(this.parentCommonMsgTimeout) clearTimeout(this.parentCommonMsgTimeout);
    }

    render() {
        if(this.parentCommonMsgTimeout) clearTimeout(this.parentCommonMsgTimeout);
        if(typeof SessionService.getCookie("isLoggedIn") === 'undefined') return null;
        this.fadeOut();
        return (
            <React.Fragment>
                { this.props.message && this.props.msgType === "rebuildError" ?
                    <div className={ "common_user_message error" } >
                        <div className="message_content">
                            { this.props.msgType === "rebuildError" ?
                                <p> Failed to perform rebuild on this instance. Please try again or <a href="https://www.idrivecompute.com/support.htm" target="_blank" rel='noopener noreferrer'>contact support.</a> </p>
                                :

                                <p dangerouslySetInnerHTML={ { __html: this.props.message } }></p>
                            }

                            <span className="close_icon" ref="close" datatoggle="tooltip" title=""
                                dataoriginaltitle="Close" onClick={ this.props.handler } ></span>
                        </div>
                    </div> :
                    this.props.message ?
                        <div className={ "common_user_message " + this.props.msgType } >
                            <div className="message_content">
                                { this.props.msgType === "rebuildError" ?
                                    <p> Failed to perform rebuild on this instance. Please try again or <a href="https://www.idrivecompute.com/support.htm" target="_blank" rel='noopener noreferrer'>contact support.</a> </p>
                                    :

                                    <p dangerouslySetInnerHTML={ { __html: this.props.message } }></p>
                                }

                                <span className="close_icon" ref="close" datatoggle="tooltip" title=""
                                    dataoriginaltitle="Close" onClick={ this.props.handler } ></span>
                            </div>
                        </div> : null
                }
            </React.Fragment>
        );
    }
}

export default CommonMessage;
